<script setup lang="ts">
import type { AsyncDataRequestStatus } from '#app'
import type { ProductCategory } from '~/types/api'

const { addSuffix } = useMeta()

const props = defineProps<{
  category: ProductCategory | null
  status: AsyncDataRequestStatus
}>()

if (props.category?.translationOfNid) {
  await useTranslatedSlugs(props.category?.translationOfNid)
}

const { t } = useI18n()

watchEffect(() => {
  useSeoMeta({
    title:
      addSuffix(props.category?.title) ?? t('pages.product-lines.meta.title'),
    description: t('pages.index.meta.description'),
  })
})
</script>

<template>
  <div class="bg-neutral-100 px-10 pb-10 lg:px-24">
    <div v-if="props.status === 'pending'">
      <UiSkeletonProductLinesOverview />
    </div>
    <div v-else>
      <ProductLinesOverview :category-id="props.category?.nid" />
    </div>
  </div>
</template>
